import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Form } from "semantic-ui-react";

const plans = {
  essential: ["users.base", "profiles.base"],
  pro: ["users.base", "profiles.*"],
  premium: [".*"],
  custom: [],
};

const planOptions = Object.keys(plans).map((plan) => ({ key: plan, value: plan, text: _.upperFirst(plan) }));

const aiBudgetOverrideFields = ["aiMonthlyBudgetBaseUsdOverride", "aiMonthlyBudgetPerUserUsdOverride"];

function normalizeOptionalNumber(value) {
  return value === "" || value === undefined ? null : Number(value);
}

function prepareOrganizationForSave(organization) {
  return {
    ...organization,
    ..._.mapValues(_.pick(organization, aiBudgetOverrideFields), normalizeOptionalNumber),
  };
}

function AiBudgetOverrideInputs({ organization, onChange }) {
  return (
    <>
      <Form.Input
        label="AI monthly budget base override (USD)"
        id="aiMonthlyBudgetBaseUsdOverride"
        min="0"
        step="0.01"
        type="number"
        value={organization.aiMonthlyBudgetBaseUsdOverride ?? ""}
        onChange={onChange}
      />
      <Form.Input
        label="AI monthly budget per-user override (USD)"
        id="aiMonthlyBudgetPerUserUsdOverride"
        min="0"
        step="0.01"
        type="number"
        value={organization.aiMonthlyBudgetPerUserUsdOverride ?? ""}
        onChange={onChange}
      />
    </>
  );
}

export function EditOrganization({ organization, onChange }) {
  const [localOrganization, setLocalOrganization] = useState({});

  useEffect(() => {
    setLocalOrganization(_.cloneDeep(organization));
  }, [organization]);

  function onLocalChange(_event, { id, value }) {
    const featureAccessList = id === "plan" ? plans[value] : localOrganization.featureAccessList;
    setLocalOrganization({ ...localOrganization, featureAccessList, [id]: value });
  }

  return (
    <Form>
      <Form.Group>
        <Form.Dropdown
          label="Plan"
          id="plan"
          options={planOptions}
          value={localOrganization.plan}
          selection
          onChange={onLocalChange}
        />
        <Form.Input
          label="Price per user and month"
          id="pricePerUserMonth"
          value={localOrganization.pricePerUserMonth}
          onChange={onLocalChange}
        />
        <Form.Input
          label="Discount per user and month"
          id="discountPerUserMonth"
          value={localOrganization.discountPerUserMonth}
          onChange={onLocalChange}
        />
        <Form.Dropdown
          label="Currency"
          id="currencyPerUserMonth"
          options={[
            { key: "sek", value: "sek", text: "SEK" },
            { key: "eur", value: "eur", text: "EUR" },
            { key: "nok", value: "nok", text: "NOK" },
          ]}
          value={localOrganization.currencyPerUserMonth}
          selection
          onChange={onLocalChange}
        />
      </Form.Group>
      <Form.Group>
        <AiBudgetOverrideInputs organization={localOrganization} onChange={onLocalChange} />
        <Form.Button
          label="Action"
          content="Save"
          onClick={() => onChange(prepareOrganizationForSave(localOrganization))}
        />
      </Form.Group>
    </Form>
  );
}
